export default {
  menuItems: {
    selectAll: {
      tooltip: "Select All (ctrl+A/command+A)",
    },
    verticalArrange: {
      tooltip: "Vertical Arrange (single column only)",
    },
    backToCenter: {
      tooltip: "Back to Center",
    },
    previousStep: {
      tooltip: "Previous Step (ctrl+Z/command+Z)",
    },
    nextStep: {
      tooltip: "Next Step (ctrl+F/command+F)",
    },
    shortcutKeys: {
      tooltip: "User Help",
    },
    addressExpand: {
      tooltip: "Expand Address",
    },
    addressCollapse: {
      tooltip: "Collapse Address",
    },
  },
};
